import { render, staticRenderFns } from "./FilterWithPeriod.vue?vue&type=template&id=ec5c791e&scoped=true"
import script from "./FilterWithPeriod.vue?vue&type=script&lang=ts"
export * from "./FilterWithPeriod.vue?vue&type=script&lang=ts"
import style0 from "./FilterWithPeriod.vue?vue&type=style&index=0&id=ec5c791e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5c791e",
  null
  
)

export default component.exports